<template>

    <div>
        <div>

            <div class="page__head container">
                <div class="page__head-inner block">
                    <h1 class="page__title page__title--icon">
                        <div class="fab-icon">
                            <i class="icon icon--dialog"></i>
                        </div>
                        Регистрация в Едином Портале Потребителей СГК
                    </h1>
                    <div class="register-form b-form b-form--lg">
                        <div class="page__descr page__descr--full">
                            Добро пожаловать в обновлённый Единый Портал Потребителей!
                        </div>
                        <div class="alert alert--info" v-if="model.Message!=''">{{model.Message}}</div>
                        <!--<span>{{model.Error}}</span>-->
                        <div class="alert alert--warning" v-if="model.Error!=''">
                            <span v-html="beginError"></span>
                        </div>

                        <div class="alert alert--error" v-if="registerError!=''">{{registerError}}</div>
                    </div>
                </div>
            </div>

            <div class="page__main container">
                <div class="page__index block">
                    <div class="register-form b-form b-form--lg">
                        <form action="" class="js-form">
                            <div class="b-form__columns">
                                <div class="b-form__column">
                                    <div class="b-form__col b-form__col--half register-form__timer-col">
                                        <div class="js-timer-container register-form__input-inner phone">
                                            <div class="b-form__col">
                                                <label class="txt-input">
                                                    <div class="txt-input__label">Номер мобильного телефона *</div>
                                                    <div class="txt-input--tip">
                                                        <div class="txt-input__input">
                                                            <div class="alert alert--success" v-if="isPhoneVerified==1 || !model.PhoneToChange">
                                                                {{phone}}
                                                            </div>
                                                            <masked-input v-if="isPhoneVerified!=1 && model.PhoneToChange"
                                                                          class="txt-input__field input req"
                                                                          :class="this.$v.phoneForApi.$invalid || phoneVerifyError!='' ? 'is-error' : ''"
                                                                          id="phone"
                                                                          type="text"
                                                                          placeholder="Введите номер телефона"
                                                                          :mask="phoneMask"
                                                                          v-model="phone" />
                                                            <div class="txt-input__required txt-input__required--error">{{phoneTypeText}}{{phoneVerifyError}}</div>
                                                            <div class="status-success txt-input__required--success" v-if="isPhoneVerified==1">Номер подтверждён</div>
                                                        </div>
                                                        <div class="txt-input__tip">
                                                            <div class="help">
                                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                                    <i class="icon icon--help"></i>
                                                                </div>
                                                                <div class="help__drop">
                                                                    <div class="help__inner">
                                                                        Номер телефона является логином и может быть указан в любом формате: 7, +7, 89…
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="b-form__col register-form__input-timer">
                                                <label class="txt-input register-form__timer-input js-input-code">
                                                    <input class="txt-input__field input req" style="width: 65%; display: inline-block "
                                                           autocomplete="off"
                                                           type="text" placeholder="Введите код" v-model="captchacode">
                                                    <img src="/Captcha/Index" style="display: inline-block">
                                                    <div class="txt-input__required--success" v-if="isPhoneVerified==1">Код введен верно</div>
                                                    <div class="input__required txt-input__required--error" v-if="isPhoneVerified==-1">Код введен неверно</div>
                                                </label>
                                            </div>
                                            <div class="b-form__col register-form__input-timer" v-if="model.PhoneToChange">
                                                <button type="button" class="button button--th-main js-poison-code" :class="(this.$v.phoneForApi.$invalid || this.captchacode.length < 5) ? 'is-disable' : ''" v-on:click="verifyPhoneStart" v-if="isPhoneVerified!=1">Отправить проверочный код</button>
                                                <div class="register-form__timer-inner js-connect-edm" style="display: none;" v-if="isPhoneVerified!=1">
                                                    <label class="txt-input register-form__timer-input js-input-code">
                                                        <input class="txt-input__field input req"
                                                               :class="isPhoneVerified==-1 ? 'is-error' : ''"
                                                               autocomplete="off"
                                                               type="text" placeholder="Введите код" v-model="phoneCode">
                                                        <div class="txt-input__required--success" v-if="isPhoneVerified==1">Код введен верно</div>
                                                        <div class="input__required txt-input__required--error" v-if="isPhoneVerified==-1">Код введен неверно</div>
                                                    </label>
                                                    <button type="button" class="button button--th-main" v-on:click="verifyPhoneCheckCode">OK</button>
                                                    <div class="form-timer js-timer">
                                                        <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                            <path stroke-dasharray="28"
                                                                  class="form-timer__circle js-timer-circle"
                                                                  d="
														M 50, 50
														m -45, 0
														a 45,45 0 1,0 90,0
														a 45,45 0 1,0 -90,0
														"></path>
                                                        </svg>
                                                        <span class="js-timer-count form-timer__count">
                                                        </span>
                                                    </div>
                                                </div>
                                                <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click="verifyPhoneStart" v-if="isPhoneVerified!=1">Отправить еще раз</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-form__col b-form__col--half register-form__timer-col">
                                        <div class="js-timer-container register-form__input-inner email">
                                            <div class="b-form__col">
                                                <label class="txt-input">
                                                    <div class="txt-input__label">Адрес электронной почты</div>
                                                    <div class="txt-input--tip">
                                                        <div class="txt-input__input">
                                                            <div class="alert alert--success" v-if="isEmailVerified==1 || !model.EmailToChange">
                                                                {{email}}
                                                            </div>
                                                            <input class="txt-input__field input" v-if="isEmailVerified!=1 && model.EmailToChange"
                                                                   :class="this.$v.email.$invalid && this.email != '' && this.email.length>4 || emailVerifyError != '' ? 'is-error' : ''"
                                                                   autocomplete="off"
                                                                   id="email"
                                                                   type="text"
                                                                   placeholder="Введите адрес эл.почты"
                                                                   v-model="email">
                                                            <div class="txt-input__required txt-input__required--error">{{emailTypeText}}{{emailVerifyError}}</div>
                                                            <div class="status-success txt-input__required--success" v-if="isEmailVerified==1">email подтверждён</div>
                                                        </div>
                                                        <div class="txt-input__tip">
                                                            <div class="help">
                                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                                    <i class="icon icon--help"></i>
                                                                </div>
                                                                <div class="help__drop">
                                                                    <div class="help__inner">
                                                                        Используется для доставки онлайн-чеков и электронных счетов
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="b-form__col register-form__input-timer" v-if="model.EmailToChange">
                                                <button type="button" class="button button--th-main js-poison-code" v-on:click="verifyEmailStart" v-if="isEmailVerified!=1">Отправить проверочный код</button>
                                                <div class="register-form__timer-inner js-connect-edm" style="display: none;" v-if="isEmailVerified!=1">
                                                    <label class="txt-input register-form__timer-input js-input-code">
                                                        <input class="input "
                                                               :class="isEmailVerified==-1 ? 'is-error' : ''"
                                                               autocomplete="off"
                                                               type="text" placeholder="Введите код" v-model="emailCode">
                                                        <div class="txt-input__required txt-input__required--error" v-if="isEmailVerified==-1">Код введен неверно</div>
                                                        <div class="txt-input__required--success" v-if="isEmailVerified==1">Код введен верно</div>
                                                    </label>
                                                    <button type="button" class="button button--th-main" v-on:click="verifyEmailCheckCode">OK</button>
                                                    <div class="form-timer js-timer">
                                                        <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                            <path stroke-dasharray="283"
                                                                  class="form-timer__circle js-timer-circle"
                                                                  d="
														M 50, 50
														m -45, 0
														a 45,45 0 1,0 90,0
														a 45,45 0 1,0 -90,0
														"></path>
                                                        </svg>
                                                        <span class="js-timer-count form-timer__count">
                                                        </span>
                                                    </div>
                                                </div>
                                                <button type="button" class="button button--th-main js-poison-code js-poison-code-again" style="display: none;" v-on:click="verifyEmailStart">Отправить еще раз</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="b-form__column">
                                    <div class="b-form__col b-form__col--half">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Логин *</div>
                                            <div class="txt-input--tip">
                                                <div class="txt-input__input">
                                                    <div class="alert alert--success" v-if="isPhoneVerified==1">
                                                        {{phoneForApi}}
                                                    </div>
                                                    <div class="alert alert--empty" v-if="isPhoneVerified!=1">
                                                        {{phoneForApi}}
                                                    </div>
                                                </div>
                                                <!--
                                                <div class="txt-input__tip">
                                                    <div class="help">
                                                        <div class="help__icon fab-icon" data-toggle="dropdown">
                                                            <i class="icon icon--help"></i>
                                                        </div>
                                                        <div class="help__drop">
                                                            <div class="help__inner">
                                                                В качестве логина вы можете использовать Ваш e&#8209;mail адрес, номер телефона или произвольный логин, указанный при регистрации на портале.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                -->
                                            </div>
                                        </label>
                                    </div>
                                    <div class="b-form__col b-form__col--half b-form__col--offset-mobile">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Как к Вам обращаться?</div>
                                            <div class="txt-input__input">
                                                <div class="alert alert--success">
                                                    {{firstName}}
                                                </div>
                                                <input class="txt-input__field input"
                                                       v-model="firstName"
                                                       type="text"
                                                       placeholder="Введите имя"
                                                       v-if="1==0">
                                            </div>
                                        </label>
                                    </div>
                                    <div class="b-form__col b-form__col--half" v-if="1==0">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Пароль *</div>
                                            <div class="txt-input--tip">
                                                <div class="txt-input__input">

                                                    <input class="txt-input__field input req is-filled js-psw-input"
                                                           :class="$v.password.$invalid && password != '' ? 'is-error' : ''"
                                                           autocomplete="off"
                                                           v-model="password"
                                                           type="password"
                                                           placeholder="Введите пароль">

                                                    <div class="txt-input__ctrl">
                                                        <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                                    </div>
                                                    <div class="txt-input__required txt-input__required--error">{{passwordTypeText}}</div>
                                                </div>
                                                <div class="txt-input__tip">
                                                    <div class="help">
                                                        <div class="help__icon fab-icon" data-toggle="dropdown">
                                                            <i class="icon icon--help"></i>
                                                        </div>
                                                        <div class="help__drop js-message-drop">
                                                            <div class="help__inner">
                                                                <span>Для защиты ваших данных необходимо придумать безопасный пароль. <br>Он должен содержать:</span> <br>
                                                                <span class="status-error js-message-length">8 и более символов</span> <br>
                                                                <span class="status-error js-message-capital">Прописные буквы [A-Z][А-Я]</span> <br>
                                                                <span class="status-error js-message-letter">Строчные буквы [a-z][а-я]</span> <br>
                                                                <span class="status-error js-message-symbol">Специальные символы [!@#$%^&amp;*()_+.]</span> <br>
                                                                <span class="status-error js-message-number">Цифры</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                    <div class="b-form__col b-form__col--half b-form__col--offset-mobile" v-if="1==0">
                                        <label class="txt-input">
                                            <div class="txt-input__label">Подтверждение пароля *</div>
                                            <div class="txt-input__input">
                                                <input class="txt-input__field input req is-filled js-psw-repeat"
                                                       :class="this.$v.confirmPassword.$invalid && this.password != '' ? 'is-error' : ''"
                                                       autocomplete="off"
                                                       v-model="confirmPassword"
                                                       type="password"
                                                       placeholder="Введите пароль повторно">


                                                <div class="txt-input__ctrl">
                                                    <div class="button-icon js-show-password"><i class="icon icon--view"></i></div>
                                                </div>
                                                <div class="txt-input__required txt-input__required--error">{{confirmPasswordTypeText}}</div>
                                            </div>
                                        </label>
                                    </div>

                                </div>
                            </div>
                            <div class="page__descr page__descr--full" v-if="model.PhoneToChange==true">
                                <h2>Внимание!</h2><br />
                                <strong>Этот номер телефона уже используется в системе Единого Портала Потребителей (ЕПП)</strong>. Для вашей безопасности и удобства важно иметь только один профиль, привязанный к данному номеру.<br /><br />
                                <h3>Что делать?</h3><br /> 
                                <p>
                                    <strong>1. Вспомните свой профиль:</strong> Попробуйте вспомнить, к какому логину привязан ваш профиль с этим номером телефона. Вы можете уточнить логин или восстановить пароль в разделе <a href='/Account/Recovery'>"Забыли логин или пароль?"</a>.<br />
                                </p><br/>
                                <p>
                                    <strong>2. Войдите в существующий профиль:</strong> Используйте логин и ваш пароль <a href='' data-drop-toggle='modalLogin'>для входа в систему</a>.
                                </p><br />
                                <p>
                                    <strong>3. Объединение профилей:</strong> Если вы успешно вошли в свой профиль, система может автоматически предложить вам объединить лицевые счета из разных профилей. Подтвердите объединение, чтобы собрать все данные в одном месте.
                                </p><br />
                                    <p>
                                        <strong>4. Если у вас возникли сложности:</strong><br /><br />
                                        &emsp;&emsp;&bull; Если вы не помните данные для входа, воспользуйтесь функцией в разделе <a href="/Account/Recovery">"Забыли логин или пароль?"</a>.<br /><br />
                                        &emsp;&emsp;&bull; Если данные не подтянулись автоматически, добавьте лицевые счета вручную в вашем профиле.<br /><br />
                                        &emsp;&emsp;&bull; Если вышеописанные инструкции Вам не помогли, напишите нам на почтовый адрес <a href="mailto:epp@sibgenco.ru?subject=Регистрация в ЕПП">epp@sibgenco.ru</a>.
                                    </p>

                            </div>
                            <div class="b-form__footer b-form__footer--reqister">
                                <div class="register-submit register-submit--offset-right">
                                    <div class="register-submit__col register-submit__col--offset-right">
                                        <div class="register-submit__check">
                                            <div class="fast-pay-submit__line">
                                                <label class="cb-input cb-input--right">
                                                    <input class="cb-input__checkbox" type="checkbox" v-model="isAgreedRules">
                                                    <span class="cb-input__check"></span>
                                                    <span class="cb-input__label">Я принимаю <a href="/site/useragreement" target="_blank" class="link link--present">«Правила пользования системой»</a></span>
                                                </label>
                                            </div>
                                            <div class="fast-pay-submit__line">
                                                <label class="cb-input cb-input--right">
                                                    <input class="cb-input__checkbox" type="checkbox" v-model="isAgreedPaymentRules">
                                                    <span class="cb-input__check"></span>
                                                    <span class="cb-input__label">
                                                        С порядком и условиями оплаты, <br>
                                                        <a href="/site/useragreement#:~:text=5,-.%20Порядок" target="_blank" class="link link--underline"><span class="link__text">зачисления</span></a> и
                                                        <a href="/site/useragreement#:~:text=5,-.%20Порядок" target="_blank" class="link link--underline"><span class="link__text">возврата</span></a> денежных средств согласен.
                                                    </span>
                                                </label>
                                            </div>
                                            <!--
                                            <div v-on:click="test">TEST</div>
                                            -->
                                        </div>

                                        <a class="register-submit__button button button--th-main"
                                           :class="(this.$v.$invalid || isPhoneVerified != 1 || !isAgreedRules || !isAgreedPaymentRules || (email != '' && isEmailVerified < 1) || inRegisterProcess) ? 'is-disable' : ''"
                                           v-on:click="Register">
                                            <span class="button__text">Зарегистрироваться</span>
                                        </a>
                                    </div>
                                    <div class="register-submit__col">
                                        <div class="register-submit__caption register-submit__caption--full ex-small">
                                            Указанные данные можно изменить в разделе "Настройки личного кабинета" после успешной регистрации
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form__message alert" data-message=""></div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="txt-input__required">{{serverResponseText}}</div>

        </div>
    </div>

</template>
<script>

    const { required, minLength, maxLength, sameAs } = window.validators
    const { validationMixin } = window.vuelidate

    import MaskedInput from 'vue-masked-input';

    import { formatMobileNumberToDigits } from '../../../../wwwroot/app/epp.utils';

    export default {
        mixins: [validationMixin],
        components: {
            'masked-input': MaskedInput,
        },
        props: {
            model: Object
        },
        mounted() {
            if (!this.model.PhoneToChange) {
                this.isPhoneVerified = 1;
            }

            if (this.model.Email != '' && !this.model.EmailToChange) {
                this.isEmailVerified = 1;
            }

            this.$nextTick(function () {
                console.log('this.model=', this.model);
                // Код, который будет запущен только после
                // отрисовки всех представлений
                this.firstName = this.model.Name;
                this.phone = this.model.Phone;
                this.email = this.model.Email;
                this.login = '';
                if (this.isPhoneVerified == 1) {
                    this.login = this.phoneForApi;
                }
            })
        },
        data: function () {
            return {
                inRegisterProcess: false,
                isServerVerify: false,
                isAgreedRules: false,
                isAgreedPaymentRules: false,
                login: '',
                password: '',
                confirmPassword: '',
                phone: '',
                captchacode: '',
                email: '',
                firstName: '',
                middleName: '',
                phoneMask: {
                    pattern: '\+7-w11-111-1111',
                    formatCharacters: {
                        'w': {
                            validate: function (char) { return /\9/.test(char) },
                            transform: function (char) { return char.toLowerCase() }
                        }
                    }
                },
                isValidateErrors: false,
                serverMessage: '',
                serverResponse: [],

                /// верификация телефона
                phoneVerifyError: '',
                isPhoneVerified: 0,
                phoneCode: '',
                /// верификация email
                emailVerifyError: '',
                isEmailVerified: 0,
                emailCode: '',
                //ошибка регистрации
                registerError: ''

            }
        },
        created() {

        },
        computed: {
            beginError: function () {
                var errs = this.model.Error.split('\n');
                var msg = '';
                for (var i = 0; i < errs.length; i++) {
                    if (msg != '') {
                        msg = msg + '<br/>';
                    }
                    msg = msg + errs[i];
                };
                msg = msg.replace("войдите с использованием пароля от ЕПП", "<a href='' data-drop-toggle='modalLogin'>войдите с использованием пароля от ЕПП</a> ");
                msg = msg.replaceAll("\"Забыли логин или пароль?\"", "<a href='/Account/Recovery'>\"Забыли логин или пароль?\"</a> ");
                //msg = msg.replace("восстановления пароля", "<a href='/Account/Recovery'>восстановления пароля</a> ");
                return msg;
            },
            passwordTypeText: function () {
                return this.$v.password.$invalid && this.password != '' ? 'Пароль не соответствует требованиям, выделенным красным цветом выше' : '';
            },
            loginTypeText: function () {
                return !this.$v.login.loginType && this.login != '' ? 'Логин может содержать буквы [A-Z][a-z][А-Я][а-я] цифры [0-9] и спецсимволы [!@#$%^&*()_+.]' : ' ';
            },
            confirmPasswordTypeText: function () {
                return this.$v.confirmPassword.$invalid && this.password != '' ? 'Пароли должны совпадать' : '';
            },
            emailTypeText: function () {
                if (this.$v.email.$invalid && this.email != '' && this.email.length > 4) {
                    this.emailVerifyError = '';
                    return 'Недопустимые символы в e-mail адресе';
                }
                return '';
            },
            phoneTypeText: function () {
                if (this.$v.phoneForApi.$invalid) {
                    this.phoneVerifyError = '';
                    return 'Номер должен содержать 10 цифр';
                }
                return '';
            },
            serverResponseText: function () {
                return this.serverMessage != '' ? this.serverMessage : 'Указанные данные можно изменить в разделе "Настройки личного кабинета" после успешной регистрации';
            },
            phoneForApi: function () {
                return formatMobileNumberToDigits(this.phone) ? formatMobileNumberToDigits(this.phone) : null;
            }
        },
        watch: {
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = '';
                }
            },
            serverResponse: function (serverResponse) {
                if (serverResponse.isSuccess) {
                    this.isValidateErrors = false;
                    this.isServerVerify = true;
                    //this.$emit('update', this.newLogin);
                    //this.serverMessage = ['Логин успешно изменён, укажите его при следующем входе'];
                } else {
                    this.isValidateErrors = true;
                    this.isServerVerify = false;
                    this.serverMessage = serverResponse.message[0];
                }
            }
        },
        validations: {
            login: {
                required: false,
                //required: required,
                maxLength: maxLength(30),
                loginType: function (value) {
                    return true;
                    //return value.match('^[A-Za-zА-Яа-я0-9!@#$%^&*()_+.]+$') ? true : false;
                }
            },
            password: {
                //required: required,
                required: false,
                //minLength: minLength(8),
                mustOneMoreUpperCase: function (value) {
                    return true;
                    //return value.match('[A-ZА-Я]+') ? true : false;
                },
                mustOneMoreLowerCase: function (value) {
                    return true;
                    //return value.match('[a-zа-я]+') ? true : false;
                },
                mustOneMoreSpecialCharacter: function (value) {
                    return true;
                    //return value.match('[!@#$%^&*()_+.]+') ? true : false;
                },
                mustOneMoreDigit: function (value) {
                    return true;
                    //return value.match('[0-9]+') ? true : false;
                }
            },
            confirmPassword: {
                sameAsconfirmPassword: sameAs('password')
            },
            phoneForApi: {
                required: required,
                length: function (value) {
                    return this.phone != '' && this.phoneForApi == null ? false : true;
                }
            },
            email: {
                required: false,
                emailType: function (value) {
                    if (value != '') {
                        return value.match('\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*') ? true : false;
                    }
                    return true;
                }
            }
        },
        methods: {
            test: function () {
                console.log("this.$v.$invalid = ", this.$v.$invalid);
                console.log("this.isPhoneVerified = ", this.isPhoneVerified);
                console.log("this.isAgreedRules = ", this.isAgreedRules);
                console.log("this.isAgreedPaymentRules = ", this.isAgreedPaymentRules);
                console.log("this.isEmailVerified = ", this.isEmailVerified);
            },
            verifyPhoneCode: async function () {
                var self = this;
                this.isValidateErrors = false;
                return await axios.post('/Register/VerifyCode', {
                    Phone: self.phoneForApi,
                    VerificationCode: self.phoneCode
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.isSuccess) {
                            self.phoneVerifyError = '';
                        }
                        else {
                            self.phoneVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        return false;
                    });
            },
            verifyEmailCode: async function () {
                console.log(" verifyEmailCode start");
                var self = this;
                this.isValidateErrors = false;

                return await axios.post('/Register/VerifyCode', {
                    Login: formId,
                    Email: self.email,
                    VerificationCode: self.emailCode
                })
                    .then(function (response) {
                        console.log(response);
                        if (response.data.isSuccess) {
                            self.emailVerifyError = '';
                        }
                        else {
                            self.emailVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        return false;
                    });
            },
            verifyEmailCheckCode: async function (event) {

                event.stopPropagation();
                this.isEmailVerified = 0;
                console.log("verifyEmailCheckCode 1 ");
                console.log("this.isEmailVerified = ", this.isEmailVerified);

                if (this.emailCode == '') {
                    return;
                }

                const container = $('.js-timer-container.email');
                const poisonCode = container.find('.js-poison-code')
                const poisonCodeAgain = container.find('.js-poison-code-again');
                const connectEdm = container.find('.js-connect-edm');
                const inputCode = container.find('.js-input-code');
                const timer = container.find('.js-timer');

                if (await this.verifyEmailCode()) {
                    console.log("Успех верификации email");
                    this.isEmailVerified = 1;
                    inputCode.hide();
                }
                else {
                    console.log("Ошибка верификации email");
                    //$("#phone").prop("disabled", false);
                    this.isEmailVerified = -1;
                }

                console.log("this.isEmailVerified = ", this.isEmailVerified);
            },

            verifyPhoneCheckCode: async function (event) {

                event.stopPropagation();
                this.isPhoneVerified = 0;
                console.log("verifyPhoneCheckCode 1 ");
                console.log("this.isPhoneVerified = ", this.isPhoneVerified);

                if (this.phoneCode == '') {
                    return;
                }
                const container = $('.js-timer-container.phone');
                const poisonCode = container.find('.js-poison-code')
                const poisonCodeAgain = container.find('.js-poison-code-again');
                const connectEdm = container.find('.js-connect-edm');
                const inputCode = container.find('.js-input-code');
                const timer = container.find('.js-timer');

                var v = await this.verifyPhoneCode();
                console.log("Успех верификации телефона ", v);

                if (v) {
                    console.log("Успех верификации телефона");
                    this.isPhoneVerified = 1;
                    inputCode.hide();
                }
                else {
                    console.log("Ошибка верификации телефона");
                    //$("#phone").prop("disabled", false);
                    this.isPhoneVerified = -1;


                    //poisonCode.hide();
                    //poisonCodeAgain.hide();

                }

                console.log("this.isPhoneVerified = ", this.isPhoneVerified);

            },
            verifyPhoneStart: function (event) {
                event.stopPropagation();

                if (this.phoneForApi == null) {
                    return;
                }

                const self = this;

                console.log("verifyPhoneStart");
                $("#phone").attr('disabled', 'disabled');
                self.phoneVerifyError = '';
                self.isPhoneVerified = 0;
                self.phoneCode = '';
                var tvalue = $('input[name="__RequestVerificationToken"]').val();
                let axiosConfig = {
                    headers: { 'RequestVerificationToken': tvalue }
                };
                const data = {
                };

                console.info(self.phoneForApi);
                axios.post('/Register/SendRequestPhoneVerify/' + self.phoneForApi + '/' + self.captchacode, data, axiosConfig)
                    .then(function (response) {
                        console.info('PhoneVerify ', response);
                        if (response.data.isSuccess) {
                            const container = $('.js-timer-container.phone');
                            const poisonCode = container.find('.js-poison-code')
                            const poisonCodeAgain = container.find('.js-poison-code-again');
                            const connectEdm = container.find('.js-connect-edm');
                            const inputCode = container.find('.js-input-code');
                            const timer = container.find('.js-timer')[0];
                            if (poisonCode.length > 0) {
                                poisonCode.hide();
                                poisonCodeAgain.hide();
                                if (connectEdm) connectEdm.show();
                                if (inputCode) inputCode.show();
                                playTimer(timer);
                                self.checkTimer(poisonCodeAgain, self.verifyPhoneAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.phoneVerifyError = response.data.message.join('');
                            $("#phone").prop('disabled', '');
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        $("#phone").prop('disabled', '');
                    });
            },
            verifyPhoneAgain() {
                $("#phone").prop('disabled', '');
            },
            verifyEmailStart: function (event) {
                if (this.email == '') {
                    return;
                }

                const self = this;

                console.log("verifyEmailStart");
                $("#email").attr('disabled', 'disabled');
                self.emailVerifyError = '';
                self.isEmailVerified = 0;
                self.emailCode = '';

                axios.post('/Register/SendRequestEmailVerify/' + formId + '/' + self.email)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            const container = $('.js-timer-container.email');
                            const poisonCode = container.find('.js-poison-code')
                            const poisonCodeAgain = container.find('.js-poison-code-again');
                            const connectEdm = container.find('.js-connect-edm');
                            const inputCode = container.find('.js-input-code');
                            const timer = container.find('.js-timer')[0];
                            if (poisonCode.length > 0) {

                                poisonCode.hide();
                                poisonCodeAgain.hide();
                                if (connectEdm) connectEdm.show();
                                if (inputCode) inputCode.show();
                                playTimer(timer);
                                self.checkTimer(poisonCodeAgain, self.verifyEmailAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.emailVerifyError = response.data.message.join('');
                            $("#email").prop('disabled', '');
                        }

                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация email невозможна, попробуйте позже';
                        $("#email").prop('disabled', '');
                    });

                event.stopPropagation();
            },
            verifyEmailAgain() {
                $("#email").prop('disabled', '');
            },

            checkTimer(timer, fn) {
                var timerInterval = null;
                timerInterval = setInterval(function () {
                    if (timer.css('display') != 'none') {
                        fn();
                        clearInterval(timerInterval);
                    }
                }, 2000);
            },

            Register: function () {
                var self = this;
                self.registerError = '';
                self.isValidateErrors = false;
                self.inRegisterProcess = true;
                self.login = self.phoneForApi;
                axios.post('/Sirius/RegisterAsync', {
                    Login: self.login,
                    Password: self.password,
                    ConfirmPassword: self.confirmPassword,
                    Phone: self.phoneForApi,
                    Email: self.email != '' && self.isEmailVerified ? self.email : '',
                    Name: self.firstName,
                    RecId: self.model.RecId,
                    IsAgreeRules: self.isAgreedRules
                })
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            window.location.href = "/fl/accounts/add";
                        }
                        else {
                            self.inRegisterProcess = false;
                            self.registerError = response.data.errors.join("\n");
                        }
                    })
                    .catch(function (error) {
                        self.inRegisterProcess = false;
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.serverMessage = ['Регистрация невозможна, попробуйте позже']
                    });
            },
        }
    }

</script>
<style>
    .error-block {
        display: block;
        color: #ef3e55;
    }

    .validated-block {
        display: block;
        color: #0078a8;
        opacity: 1;
    }

    .show {
        display: block;
    }

    .hide {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// Scripts/app/register/components/RegisterSirius.vue